// extracted by mini-css-extract-plugin
export var width100 = "Q_w d_w";
export var design3Pos = "Q_wQ d_0";